import React from "react";
import R1 from "../assets/aadhaar.png";
import r2 from "../assets/transaction.png";
import r3 from "../assets/processing.png";
import "../App.css";

const HowIts = () => {
  return (
   <div
      className="container text-center py-lg-5 py-3 how-wrapper"
      id="how-it-works"
    >
      <h2 className="fw-bold mb-2">HOW IT WORKS</h2>
      <p className="text-muted mb-5">
        Banking made simple in just 3 easy steps
      </p>

      {/* Steps Wrapper */}
      <div className="d-flex flex-md-row flex-column justify-content-between align-items-center how-steps gap-4 gap-lg-0">
        
        {/* Step 1 */}
        {/* <div className="step-boxs mb-4 mb-lg-0">
          <div className="circle filled">
            <img src={R1} alt="step1" />
          </div>
          <h5 className="fw-bold mt-3">Aadhaar Authentication</h5>
          <p className="text-muted">
            To begin, users need to authenticate their identity using their Aadhaar number and biometric data (fingerprint or iris scan).
          </p>
        </div> */}
        <div className="step-boxs mb-4 mb-lg-0">
          <div className="circle dotted">
            <img src={R1} alt="step2" />
          </div>
          <h5 className="fw-bold mt-3">Aadhaar Authentication</h5>
          <p className="text-muted">
            To begin, users need to authenticate their identity using their Aadhaar number and biometric data (fingerprint or iris scan).
          </p>
        </div>

        {/* Step 2 */}
        <div className="step-boxs mb-4 mb-lg-0">
          <div className="circle dotted">
            <img src={r2} alt="step2" />
          </div>
          <h5 className="fw-bold mt-3">Transaction Request</h5>
          <p className="text-muted">
            Once authenticated, the user can initiate banking transactions like cash withdrawals, balance checks, and fund transfers.
          </p>
        </div>

        {/* Step 3 */}
        <div className="step-boxs mb-4 mb-lg-0">
          <div className="circle dotted">
            <img src={r3} alt="step3" />
          </div>
          <h5 className="fw-bold mt-3">Processing the Transaction</h5>
          <p className="text-muted">
            After successful biometric verification, the transaction is processed by the bank, which checks the user’s account for the requested service.
          </p>
        </div>
      </div>

      {/* Curved dotted connectors */}
      <div className="curves curve-left d-none d-lg-block">
        <div className="arrow-right"></div>
      </div>
      <div className="curve curve-right d-none d-lg-block">
        <div className="arrow-left"></div>
      </div>
    </div>
  );
};

export default HowIts;
 